import { useEffect, useState } from 'react';
import { ReloadOutlined } from '@ant-design/icons';
import { App, Button } from 'antd';
import { AxiosError } from 'axios';
import { delay } from 'lodash';

import { useStartPullBundleAccessMembership } from '../../subscriptions/data';

export type StartPullBundleAccessMembershipsButtonArgs = {
  bundleId: number;
  onReload?: () => void;
};

export const StartPullBundleAccessMembershipsButton = ({
  bundleId,
  onReload,
}: StartPullBundleAccessMembershipsButtonArgs) => {
  const [retryDelay, setRetryDelay] = useState(false);
  const { notification } = App.useApp();
  const triggerPull = useStartPullBundleAccessMembership();

  useEffect(() => {
    if (triggerPull.isSuccess) {
      notification.success({
        message: 'Subscription Pull Started',
        description:
          'Repull was successful started.  Refresh the page to see fresh results.  Note that it can take several minutes to complete.',
      });
    }

    if (triggerPull.isError) {
      const error = triggerPull.error as AxiosError;

      notification.error({
        message: 'Repull Error, please try again.',
        description: error.message,
        duration: 0, // force user to close
      });
    }
  }, [notification, triggerPull.error, triggerPull.isError, triggerPull.isSuccess]);

  return (
    <Button
      icon={<ReloadOutlined />}
      title="Click this to pull the latest memberships from the source systems and update this bundle's subscriptions.  If the bundle has eager subscriptions enabled they will be refreshed as well."
      onClick={() => {
        setRetryDelay(true);
        delay(() => {
          triggerPull.mutate(bundleId, { onSettled: () => onReload && onReload() });
          setRetryDelay(false);
        }, 800);
      }}
      loading={retryDelay || triggerPull.isPending}
    >
      Repull Memberships
    </Button>
  );
};
